<template>
    <div>
        This is the vehicles page
    </div>
</template>